import React from "react";
import PropTypes from "prop-types";
import { headerNavigationConstants } from "constants/navigationConstants";
import { HeaderNavigationContainer } from "./HeaderNavigation.styled";
import HeaderNavigationItem from "./HeaderNavigationItem/HeaderNavigationItem";
import DropdownNavigationItem from "../HeaderDropdownNavigationItem/HeaderDropdownNavigationItem";

const HeaderNavigation = () => {
  return (
    <HeaderNavigationContainer>
      {headerNavigationConstants.map((singleNavigationItem, index) => {
        if (singleNavigationItem.dropdown) {
          return (
            <DropdownNavigationItem
              key={index}
              routes={[
                { title: singleNavigationItem.title },
                ...singleNavigationItem.dropdown,
              ]}
            />
          );
        }

        return (
          <HeaderNavigationItem key={index} route={singleNavigationItem} />
        );
      })}
    </HeaderNavigationContainer>
  );
};

HeaderNavigation.propTypes = {
  children: PropTypes.node,
};

export default HeaderNavigation;
